const SERVICE_COVID_19_TEST = "COVID_19_TEST";
const SERVICE_FLU_SHOT = "FLU_SHOT";
const SERVICE_CONSULT = "CONSULT";

export { SERVICE_COVID_19_TEST, SERVICE_FLU_SHOT, SERVICE_CONSULT };
